var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"11","viewBox":"0 0 14 11","fill":"none"}},[_c('path',{attrs:{"d":"M4.66667 7.69533L12.355 0L14 1.65817L4.66667 11L0 6.32909L1.645 4.68259L4.66667 7.69533Z","fill":"#FFB800"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }